import Component from '../classes/Component';
import {$dom} from "../helpers/dom";

const modalId = 'js-modal-notify';
const rootAttr = 'data-status';
const titleSelector = '.js-modal-notify-title';
const descriptionSelector = '.js-modal-notify-description';

export default function () {

    const $Page = this;

	return new Component({
		name: 'notify',
		requiredTargets: '#'+modalId,
		onInit() {
		    this.show = (params = {}) => {
		        const rootEl = $dom.get(`[${rootAttr}]`, this.targets[0]);
		        const {title, status, description} = params;

                if ($dom.exist(titleSelector, rootEl) && $dom.exist(descriptionSelector, rootEl)) {
                    const titleEl = $dom.get(titleSelector, rootEl);
                    const descriptionEl = $dom.get(descriptionSelector, rootEl);

                    if (status) {
                        $dom.attr(rootEl, rootAttr, status);
                        if (title) {
                            $dom.removeClass(titleEl, 'd-none');
                            $dom.html(titleEl, title);
                        } else {
                            $dom.addClass(titleEl, 'd-none');
                        }

                        if (description) {
                            $dom.removeClass(descriptionEl, 'd-none');
                            $dom.html(descriptionEl, description);
                        } else {
                            $dom.addClass(descriptionEl, 'd-none');
                        }

                        $Page.components.modal.open(modalId);
                    }
                }
            }
        }
	})
}
